import { RootState } from './index';
import { createSelector } from '@reduxjs/toolkit';

export const getMetaData = (state: RootState) => state.metaData;
export const metaDataSelector = createSelector(getMetaData, (state) => state);
